import app from 'flarum/app';
import {extend, override} from 'flarum/extend';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import IndexPage from 'flarum/forum/components/IndexPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import Button from 'flarum/common/components/Button';
import CardItem from './components/CardItem';
import ListItem from './components/ListItem';

// 导出一个全局列数状态
export let currentFlexColumns = 2;

let flexCardObserver = null;
let resizeTimeout = null;
let layoutUpdateTimer = null; 

/**
 * 根据容器宽度计算列数
 * 遵循你最新的计算公式
 */
function getColumnsCount(width) {
  if (width < 600) return 2;
  if (width < 1000) return 4;
  if (width < 3000) {
    return 6 + Math.floor((width - 1000) / 500) * 2;
  }
  return 14 + Math.floor((width - 3000) / 800) * 2;
}

/**
 * 暴露给子组件的全局布局触发器
 */
export function triggerLayoutUpdate(container) {
  if (!container) return;
  clearTimeout(layoutUpdateTimer);
  layoutUpdateTimer = setTimeout(() => {
    updateContainerLayout(container);
  }, 50);
}






/**
 * 核心布局修正逻辑
 */
/**
/**
 * 核心布局修正逻辑（包含跨类型的网格计算，以及独立类型的孤立计算）
 */
 //孤立元素计算方法
/**
 * 孤立元素计算方法 - 改为纯内存计算，返回一个 Set 集合
 */


const toggleClass = (item, cls, state) => {
  if (item.classList.contains(cls) !== state) {
    item.classList.toggle(cls, state);
  }
};

// 孤立元素计算：找出孤立的，然后当场把所有人的状态更新准
// 增加 checkEnd 参数，默认开启末尾校验
const calculateIsolated = (itemsArray, checkEnd = true) => {
  let normalCount = 0;
  let lastNormal = null;
  const isolatedItems = []; // 临时存一下谁是孤立的

  itemsArray.forEach((item) => {
    if (item.classList.contains('is-flat-img')) {
      if (normalCount % 2 !== 0 && lastNormal) {
        isolatedItems.push(lastNormal);
      }
      normalCount = 0;
      lastNormal = null;
    } else {
      normalCount++;
      lastNormal = item;
    }
  });
  
  // 根据传入的开关决定是否校验末尾
  if (checkEnd) {
    if (normalCount % 2 !== 0 && lastNormal) {
      isolatedItems.push(lastNormal);
    }
  }

  // 算完了当场改：在列表里的就是 true，不在的就是 false
  itemsArray.forEach(item => {
    toggleClass(item, 'is-isolated-card', isolatedItems.includes(item));
  });
};
export function updateContainerLayout(container) {
  if (!container) return;
  const allItems = Array.from(container.querySelectorAll('.CardsListItem'));
  const cards = Array.from(container.querySelectorAll('.CardsListItem.Card'));
  const lists = Array.from(container.querySelectorAll('.CardsListItem.List'));
  
  const cols = parseInt(container.style.getPropertyValue('--columns')) || 2;

  // 0. 隔离标记计算：算完直接更新 DOM
  calculateIsolated(cards,true);
  calculateIsolated(lists,false);
  
  let currentLineSpans = 0;
  let totalWaterLevel = 0; // 全局累计水位
  const itemWaterLevels = new Array(allItems.length).fill(0); // 存每个元素叠加后的绝对水位
  
  // 1. 正序遍历：决定膨胀逻辑与水位累加
  for (let i = 0; i < allItems.length; i++) {
    let item = allItems[i];
    let baseSpan = item.classList.contains('is-flat-img') ? 2 : 1;
    
    // 提行判定
    if (currentLineSpans + baseSpan > cols) {
      currentLineSpans = 0;
    }
    
    let remainingSpace = cols - currentLineSpans - baseSpan;
    let finalSpan;
    let shouldExpand = false; // 记录当前卡片到底该不该膨胀

    if (item.classList.contains('is-flat-img')) {
      if (remainingSpace >= 2) {
        shouldExpand = true;
        finalSpan = 4;
      } else {
        finalSpan = 2; 
      }
    } else {
      if (remainingSpace >= 1) {
        shouldExpand = true;
        finalSpan = 2;
      } else if (item.classList.contains('is-isolated-card')) {
        finalSpan = 2;
      } else {
        finalSpan = 1; 
      }
    }

    // 【算完立马改】：该膨胀就加上，不该膨胀就去掉，一样就不动
    toggleClass(item, 'can-expand', shouldExpand);

    // 【核心改动】：累加真实水位并存储
    totalWaterLevel += finalSpan;
    itemWaterLevels[i] = totalWaterLevel;
    
    currentLineSpans += finalSpan;
  }

  // 2. 底部判定：利用绝对水位进行精准切割
    // 倒数第二行的最终水位 = 整体总水位 - 最后一行积累的 spans
    let bottomThreshold = totalWaterLevel - currentLineSpans;
    let bottomIndex=allItems.length - 1;
    for (let i = bottomIndex; i >= 0; i--) {
      // 只要该元素的水位超过了上一行的界限，它必定在最后一行
      let shouldBeBottom = (itemWaterLevels[i] > bottomThreshold) ;//避免产生新提行互为因果
      if(shouldBeBottom)bottomIndex=i
      toggleClass(allItems[i], 'is-bottom-card', shouldBeBottom);
    }
 
}


/**
 * 挂载 ResizeObserver
 */
function initResizeObserver(dom) {
  if (!flexCardObserver) {
    flexCardObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width;
        const cols = getColumnsCount(width);
        
        if (currentFlexColumns !== cols) {
          currentFlexColumns = cols;
          entry.target.style.setProperty('--columns', cols);
          
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            updateContainerLayout(entry.target);
          }, 150);
        }
      }
    });
  }
  flexCardObserver.observe(dom);
  
  // 首次运行
  const initialWidth = dom.getBoundingClientRect().width;
  currentFlexColumns = getColumnsCount(initialWidth);
  dom.style.setProperty('--columns', currentFlexColumns);
  // 初始化时也跑一次布局标记
  updateContainerLayout(dom);
}

function destroyResizeObserver(dom) {
  if (flexCardObserver) {
    flexCardObserver.unobserve(dom);
  }
}

app.initializers.add('dem13n/discussion/cards', () => {

  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (app.current.matches(IndexPage)) {
     // params.include.push(['firstPost', 'posts', 'posts.user']);
    }
  });

  override(DiscussionList.prototype, 'view', function (original) {
    const settings = JSON.parse(app.forum.attribute('dem13nDiscussionCards'));
    const state = this.attrs.state;
    const params = state.getParams();
    let loading;
    let cardThreshold=window.innerWidth>600?8:4
    if (state.isInitialLoading() || state.isLoadingNext()) {
      loading = <LoadingIndicator/>;
    } else if (state.hasNext()) {
      loading = Button.component(
        {
          className: 'Button',
          onclick: state.loadNext.bind(state),
        },
        app.translator.trans('core.forum.discussion_list.load_more_button')
      );
    }
    
    if (state.isEmpty()) {
      const text = app.translator.trans('core.forum.discussion_list.empty_text');
      return <div className="DiscussionList flexCardContiner">{m(Placeholder, {text})}</div>;
    }
    
    if (app.current.matches(IndexPage) && ((settings.allowedTags.length && settings.allowedTags.includes(params.tags)) || (!params.tags && settings.onIndexPage === 1))) {
      return (
        <div className={'DiscussionList' +  ' flexCardContiner '+ (state.isSearchResults() ? ' DiscussionList--searchResults' : '')}>
          <div 
            className="DiscussionList-discussions flexCard"
            oncreate={(vnode) => initResizeObserver(vnode.dom)}
            onremove={(vnode) => destroyResizeObserver(vnode.dom)}
          >
            {state.getPages().map((pg, o) => {
              return pg.items.map((discussion, i) => {
                return (i < cardThreshold && o === 0)
                  ? m(CardItem, {discussion: discussion})
                  : m(ListItem, {discussion: discussion})
              });
            })}
          </div>
          <div className="DiscussionList-loadMore">{loading}</div>
        </div>
      );

    } else {
      return original();
    }
  })
}, -1);